const mainProductUpsells = document.querySelector('.main-product-upsells');
const mainProductUpsellsClose = mainProductUpsells.querySelector('#close');
const mainProductUpsellsButtons = mainProductUpsells.querySelectorAll('.button');

const productFormSubmit = document.querySelector('.product .product-form__submit');

const data = {'items':[]};

function openMainProductUpsells(){
    mainProductUpsells.classList.add('open');
}

function closeMainProductUpsells(){
    mainProductUpsells.classList.remove('open');
}

mainProductUpsellsClose.addEventListener('click', () => {
    closeMainProductUpsells();
})

mainProductUpsellsButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      
        console.log(btn.dataset.productId);
      
        let productInfo = {id: btn.dataset.productId, quantity: 1}
        data['items'].push(productInfo);
        addToCart(data);
      
        closeMainProductUpsells();
    })
})

productFormSubmit.addEventListener('click', () => {
  if(productFormSubmit.dataset.upsells == "true"){
    openMainProductUpsells();
  }
})